module.exports = __webpack_public_path__ + "static/media/analytices6.633407d7.jpg";